.header {
    padding-left: 15px;
    display: flex;
    justify-content: space-between;
    h1 {
        font-size: 18px;
        margin: 5px;
    }
    .darkModeSwitchGroup {
        margin: 5px 10px;
        > * {
            margin-left: 3px;
        }
        display: flex;
        align-items: center;
        svg {
            height: 20px;
            margin: 2px 2px 0 4px;
            path {
                fill: var(--secondary);
            }
            &.isActive path {
                fill: var(--primary);
            }
        }
        .switchInput {
            position: relative;
            display: inline-block;
            cursor: pointer;
            width: 40px;
            height: 22px;
        }
    }
}
